/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import LoadingSpinner from 'DesignSystem/LoadingSpinner/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/ScheduleOptions/Content/UntemplatedSlot/Loading"
  
}) {
  return (<React.Fragment
>
<LoadingSpinner
  viewPath={`${viewPath}/LoadingSpinner`}
 delay={0}
 height={15}
 width={15}
/>
{children}
</React.Fragment>)
}